<template>
	<v-container>
		<v-alert v-if="alertCriticas() && reprovado" color="error" :value="true" class="mb-3 mt-0">
			Instruções
			<ul>
				<li class="mb-1 mt-3">
					Os campos que contém inconsistências estão marcados em vermelho, com um texto detalhando a razão da reprovação.
				</li>
			</ul>
		</v-alert>
		<v-card class="elevation-1">
			<v-toolbar flat dark color="primary">
				<v-toolbar-title>Arquivos</v-toolbar-title>
				<v-spacer />
			</v-toolbar>
			<v-expansion-panel>
				<v-expansion-panel-content v-for="(p, indexP) in pessoas" :key="indexP">
					<template v-slot:header>
						<v-layout row align-center>
							<v-icon v-if="checkPessoa(p.id) && reprovado || !p.completo" color="warning" class="mr-2" dark>error</v-icon>
							<v-icon v-else color="primary" class="mr-2" dark>check</v-icon>
							<span>{{ p.nome }}</span>
						</v-layout>
					</template>
					<v-alert v-if="checkPessoa(p.id) && reprovado" color="error" :value="true" class="mb-3 mt-0 mr-3 ml-3">
						Inconsistências
						<ul>
							<li class="mb-1 mt-3">
								{{ getCritica(p.id) }}
							</li>
						</ul>
					</v-alert>
					<v-layout row wrap class="px-2">
						<v-flex v-for="(d, indexD) in p.documentos" v-if="d.obrigatorio" :key="indexD" xs12 md6 class="px-2 pb-3">
							<v-card>
								<v-toolbar flat dark dense color="secondary">
									<v-toolbar-title style="font-size:16px;white-space:wrap;">{{ d.nome }}</v-toolbar-title>
									<v-spacer />
									<v-upload-file
										v-if="$vuetify.breakpoint.smAndUp && checkEditar.result && (pendente || reprovado)"
										class="btn-upload-file"
										:size="1024 * 1024 * 10"
										@file-selected="e => uploadFile(e, p.id, d.id)"
										@file-error="showFileError"
									/>
								</v-toolbar>
								<v-list v-if="$vuetify.breakpoint.smAndUp" two-line class="list-documents py-0">
									<template v-for="(f, indexF) in d.files">
										<v-list-tile :key="indexF" class="px-2">
											<v-list-tile-content>
												<v-list-tile-title style="font-size:14px;">
													<a
														v-if="checkCritica(p.id, f.id) && editar"
														class="red--text"
														:href="`${baseUrl}/inscricao/anexo/${f.id}/download`"
														target="_blank"
													>{{ f.name }}</a>
													<a
														v-else
														:href="`${baseUrl}/inscricao/anexo/${f.id}/download`"
														target="_blank"
													>{{ f.name }}</a>
												</v-list-tile-title>
											</v-list-tile-content>
											<v-list-tile-action v-if="checkEditar.result && pendente || reprovado">
												<v-icon color="danger" @click.prevent="deleteFile(f.id)">delete</v-icon>
											</v-list-tile-action>
											<v-list-tile-action v-else>
												<v-icon color="grey">delete</v-icon>
											</v-list-tile-action>
										</v-list-tile>
										<v-divider v-if="indexF + 1 < d.files.length" :key="`div_${indexF}`" />
									</template>
									<template v-if="!d.files || d.files.length === 0">
										<v-list-tile class="px-2">
											<v-list-tile-content>
												<v-list-tile-title style="font-size:14px;">Nenhum arquivo adicionado.</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
									</template>
								</v-list>
								<template v-else>
									<div class="px-2 pt-1 pb-0">
										<v-upload-file
											:ref="`uploadFile-${p.id}-${d.id}`"
											:size="1024 * 1024 * 10"
											@file-selected="e => uploadFile(e, p.id, d.id)"
											@file-error="showFileError"
										>
											<v-btn
												:disabled="(!checkEditar.result || d.files.length >= 2 && (!reprovado || !pendente))"
												block
												color="primary"
												@click="() => $refs[`uploadFile-${p.id}-${d.id}`][0].openFileDialog()"
											>
												Adicionar
											</v-btn>
										</v-upload-file>
									</div>
									<v-expansion-panel class="panel-documents">
										<v-expansion-panel-content v-for="(f, indexF) in d.files" :key="indexF">
											<template v-slot:header>
												<v-layout row align-center>
													<a v-if="checkCritica(p.id, f.id) && editar"
														class="red--text"
														:href="`${baseUrl}/inscricao/anexo/${f.id}/download`"
														target="_blank"
													>
														{{ f.name }}
													</a>
													<a v-else :href="`${baseUrl}/inscricao/anexo/${f.id}/download`" target="_blank">
														{{ f.name }}
													</a>
												</v-layout>
											</template>
											<v-layout class="px-3 pb-3">
												<v-btn
													v-if="checkEditar.result && pendente || reprovado || pendente"
													block dark color="danger"
													@click.prevent="deleteFile(f.id)"
												>
													Remover
												</v-btn>
											</v-layout>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</template>
							</v-card>
						</v-flex>
					</v-layout>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-card>

		<v-loading :show="loading" message="Processando requisição" />

		<v-confirm-dialog ref="confirmDialog" />
	</v-container>
</template>
<script>
	import VConfirmDialog from '@/components/confirmDialog';
	import VLoading from '@/components/loading';
	import VUploadFile from '@/components/uploadFile';
	import api from '@/services/api';

	export default {
		components: {
			VUploadFile,
			VConfirmDialog,
			VLoading
		},

		data() {
			return {
				editar: null,
				pessoas: null,
				baseUrl: window.Config.BASE_URL,
				loading: false,
				criticas: [],
				reprovado: false,
				pendente: false
			};
		},

		computed: {
			checkEditar() {
				if (this.editar) {
					return { result: true };
				} else {
					return { result: false };
				}
			}
		},

		async created() {
			this.fetchAnexos();

			let editar = (await api.fetchStatus());

			this.reprovado = editar.data.situacaoInscricao.descricao == 'Reprovada';

			this.pendente = editar.data.situacaoInscricao.descricao == 'Pendente';

			let { criticas } = editar.data;

			this.criticas = criticas;

			this.editar = editar.data.operacoes.editar;
		},

		methods: {
			async fetchAnexos() {
				try {
					this.loading = true;

					this.pessoas = (await api.fetchAnexos()).data;
				} catch ({ data: { message } }) {
					if (message) {
						this.$store.$emit('show-message', {
							message,
							timeout: 5000,
							color: 'danger'
						});
					}
				} finally {
					this.loading = false;
				}
			},

			async uploadFile(e, idPessoa, idTipoDocumento) {
				let file = e.target.files[0];

				try {
					this.loading = true;

					await api.saveAnexo(file, idPessoa, idTipoDocumento);

					await this.fetchAnexos();

					this.$store.$emit('show-message', {
						message: 'Arquivo adicionado com sucesso!',
						color: 'success'
					});
				} catch (err) {
					if (err.data && err.data.message) {
						this.$store.$emit('show-message', {
							message: err.data.message,
							timeout: 5000,
							color: 'danger'
						});
						return false;
					}

					this.$store.$emit('show-message', {
						message: 'Erro ao enviar anexo. Verifique sua conexão e tente novamente!',
						timeout: 5000,
						color: 'danger'
					});

				} finally {
					this.loading = false;
				}
			},

			alertCriticas() {
				let keys = Object.keys(this.criticas);

				for (let i = 0; i < keys.length; i++) {
					if (keys[i].includes('responsavel') || keys[i].includes('membroFamilia')) {
						return true;
					}
				} return false;
			},

			checkPessoa(id) {
				let keys = Object.keys(this.criticas);

				if (id == this.pessoas[0].id) {
					for (let i = 0; i < keys.length; i++) {
						if (keys[i].includes(`responsavel.${id}.pessoaAnexo`)) {
							return true;
						}
					} return false;
				} else {
					for (let i = 0; i < keys.length; i++) {
						if (keys[i].includes(`membroFamilia.${id}.pessoaAnexo`)) {
							return true;
						}
					} return false;
				}

			},

			getCritica(id) {
				if (id == this.pessoas[0].id) {
					return this.criticas[`responsavel.${id}.pessoaAnexo`];
				} else {
					return this.criticas[`membroFamilia.${id}.pessoaAnexo`];
				}
			},

			checkCritica(id, id2) {
				if (id === this.pessoas[0].id) {
					if (this.criticas[`responsavel.${id}.pessoaAnexo.${id2}.idAnexo`]) {
						return true;
					} else {
						return false;
					}
				} else {
					if (this.criticas[`membroFamilia.${id}.pessoaAnexo.${id2}.idAnexo`]) {
						return true;
					} else {
						return false;
					}
				}
			},

			showFileError(error) {
				this.$store.$emit('show-message', {
					message: error,
					timeout: 5000,
					color: 'danger'
				});
			},

			deleteFile(id) {
				this.$refs.confirmDialog
					.open('Confirma a remoção deste arquivo?')
					.then(async response => {
						if (response) {
							try {
								this.loading = true;

								await api.deleteAnexo(id);

								await this.fetchAnexos();

								this.$store.$emit('show-message', {
									message: 'Arquivo removido com sucesso!',
									color: 'success'
								});
							} catch ({ data: { message } }) {
								if (message) {
									this.$store.$emit('show-message', {
										message,
										timeout: 5000,
										color: 'danger'
									});
								}
							} finally {
								this.loading = false;
							}
						}
					});
			}
		}
	};
</script>

<style scoped>
	.list-documents [role="listitem"]:hover {
		background: #fff9c4;
	}

	.panel-documents .v-expansion-panel__container--active {
		background: #fff9c4 !important;
	}

	.btn-upload-file >>> button {
		margin-right: -5px !important;
	}
</style>